import { BroadcastChannels } from 'shared/constants/broadcast/channels'
import {
  AppFocusChangeMessage,
  NotificationsBroadcastMessages
} from 'shared/constants/broadcast/notifications'
import { FEATURE_FLAGS } from 'shared/constants/featureFlags'
import { logger } from 'shared/services/logger'
import { postMessage } from 'shared/utils/broadcastChannel'
import { getContainerTabId } from 'shared/utils/getContainerTabId'

export const broadcastAppFocusChange = (
  appIdDefocused: string | null,
  appIdFocused: string | null
): void => {
  const message: AppFocusChangeMessage = {
    type: NotificationsBroadcastMessages.APP_FOCUS_CHANGE,
    payload: {
      appIdDefocused,
      appIdFocused,
      tabId: getContainerTabId(),
      at: new Date().toISOString()
    }
  }

  postMessage(BroadcastChannels.NOTIFICATIONS, message)

  if (FEATURE_FLAGS.APP_FOCUS_CHANGE_DEV_LOGGING_ENABLED) {
    logger.debug('ui.app_focus_changed', { ...message.payload })
  }
}
